import axios from "axios";
import Vue from "vue";
export const state = {
  positions: [],
  staff: [],
  staff_details: {},
  save_status: false,
};
export const getters = {
  AllPositions: (state) => state.positions.data,
  AllStaff: (state) => state.staff.data,
  Staff: (state) => state.staff_details.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_POSITIONS(state, newValue) {
    state.positions = newValue;
  },
  SET_STAFF(state, newValue) {
    state.staff = newValue;
  },
  SET_STAFF_DETAILS(state, newValue) {
    state.staff_details = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addPosition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("positions", payload)
      .then(() => {
        dispatch("fetchPositions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit Staff Position
  editPosition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`positions/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchPositions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Staff Position
  deletePosition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`positions/${payload.id}`)
      .then(() => {
        dispatch("fetchPositions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addStaff({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("staff", payload)
      .then(() => {
        dispatch("fetchStaff");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Staff Member Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Staff
  editStaff({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`staff/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchStaff");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Staff Member Was Edit Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Staff",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Staff Position
  deleteStaff({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`staff/${payload.id}`)
      .then(() => {
        dispatch("fetchStaff");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Staff Member Was Deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Staff",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addLoad({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("load", payload)
      .then(() => {
        dispatch("fetchStaffDetails", payload.staff);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Load assigned to Staff Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred while Appling Load",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  deleteLoad({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`load/${payload.id}`)
      .then(() => {
        dispatch("fetchStaffDetails", payload.staff);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Load deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred while Deleting Load",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchPositions({ commit }) {
    axios.get(`positions`).then((pos) => {
      commit("SET_POSITIONS", pos.data);
    });
  },
  fetchStaff({ commit }) {
    axios.get(`staff`).then((sta) => {
      commit("SET_STAFF", sta.data);
    });
  },
  fetchStaffDetails({ commit }, id) {
    axios.get(`staff/${id}`).then((sta) => {
      commit("SET_STAFF_DETAILS", sta.data);
    });
  },
};
